import { Box } from "@mui/material";

import {
  AddRepButton,
  GroupByBrokerCheckbox,
  RepBrokerSelect,
} from "../components";
import { MOCK_BROKERS } from "../mock";

interface CarrierRepsFiltersProps {
  onAddRep: () => void;
}

export const CarrierRepsFilters = ({
  onAddRep,
}: CarrierRepsFiltersProps): React.JSX.Element => (
  <Box
    data-testid="carrier-reps-filters"
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    gap={2}
  >
    <Box display="flex" alignItems="center" gap={2}>
      <RepBrokerSelect brokers={MOCK_BROKERS} />
      <GroupByBrokerCheckbox />
    </Box>
    <AddRepButton onClick={onAddRep} />
  </Box>
);
